import { FC, useRef, useState } from "react";
import { Formik, FormikProps } from "formik";
import _ from "lodash";
import { BackIcon, FormWrapper, Header, HeaderText, LeftSideWrapper, RightSideWrapper, Wrapper } from "./elements";
import back from "../../../assets/icons/back.svg";
import { Button } from "../../atoms/Button";
import { PositionForm } from "../../organisms/PositionForm";
import { CreatePositionSchema } from "./validation";

type Props = {
  onBack?: () => void;
  onCreatePosition: (values: any) => void;
  isLoading?: boolean;
}

const CreatePosition: FC<Props> = ({ onCreatePosition, onBack, isLoading }) => {
  const formRef = useRef<FormikProps<any>>(null);
  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [isAccountActive, setIsAccountActive] = useState(false);
  const initialValues = { position: "", status: "Closed", skills: [] };

  const handleSwitchStatus = () => {
    setPopConfirmVisible(true);
  }

  const onConfirm = () => {
    setPopConfirmVisible(false);
    setIsAccountActive(!isAccountActive);
    formRef.current?.setFieldValue('status', !isAccountActive ? 'Open' : 'Closed');
  }
  
  const onCancel = () => {
    setPopConfirmVisible(false);
  }

  return (
    <Wrapper>
      <Formik
        innerRef={formRef}
        onSubmit={onCreatePosition}
        initialValues={{ ...initialValues }}
        validateOnMount
        validateOnBlur
        validateOnChange
        validationSchema={CreatePositionSchema}
      >
        {({ values, handleChange, errors, isValid, setFieldValue, handleSubmit, isSubmitting }) => (
          <>
            <Header>
              <LeftSideWrapper>
                <BackIcon src={back} onClick={onBack} />
                <div>
                  <HeaderText>Create Position</HeaderText>
                </div>
              </LeftSideWrapper>
              <RightSideWrapper>
                <Button type="primary" disabled={isLoading || !isValid} onClick={handleSubmit}>Save</Button>
              </RightSideWrapper>
            </Header>
            <FormWrapper>
              <PositionForm 
                isAccountActive={isAccountActive}
                innerRef={formRef}
                handleSwitchStatus={handleSwitchStatus} 
                onConfirm={onConfirm} 
                onCancel={onCancel} 
                popConfirmVisible={popConfirmVisible} 
                onChangePosition={handleChange('position')}
                setFieldValue={setFieldValue}
                values={values}
                errors={errors}
                isSubmitting={isSubmitting}
              />
            </FormWrapper>
          </>
        )}
      </Formik>
    </Wrapper>
  )
}

export default CreatePosition;